import { typographyClasses } from '@mui/material/Typography';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CSSProperties } from 'react';

const defaultVideoPlayerStyles = makeStyles(({ palette, spacing }) => {
  const sharedStyle: CSSProperties = {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
  };

  const sharedFlexStyles: CSSProperties = {
    justifyContent: 'center',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
  };

  const sharedWidthHeight: CSSProperties = {
    width: '100%',
    height: '100%',
  };

  return createStyles({
    videoWrapper: {
      ...sharedWidthHeight,
    },
    video: {
      ...sharedWidthHeight,
      objectFit: 'fill',
      objectPosition: 'center',
    },
    loading: {
      ...sharedStyle,
      ...sharedFlexStyles,
    },
    unavailable: {
      [`& .${typographyClasses.body2}`]: {
        color: palette.error.main,
      },
    },
    unavailableWrapper: {
      ...sharedStyle,
      ...sharedFlexStyles,
    },
    retryWrapper: {
      paddingTop: spacing(2),
      color: palette.common.white,
    },
    retryButton: {
      color: palette.common.white,
    },
  });
});

export default defaultVideoPlayerStyles;
